var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin__home"},[_c('OnboardHeader'),_c('div',{staticClass:"admin__home--left-div"},[_vm._v("\n    OnboardSidebar\n    "),_c('OnboardSidebar',{attrs:{"item":_vm.item}})],1),_c('div',{staticClass:"admin__home--right-div"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }